import Vue from 'vue';
import gql from 'graphql-tag';

const emptyAddress = {
    id: null,
    firstName: null,
    lastName: null,
    company: null,
    street: null,
    postCode: null,
    city: null,
    country: '',
    houseNumber: null,
    ...(Vue.$session.get('customer-address-shipping') || {}),
};

export default {
    namespaced: true,
    state: {
        loading: false,
        address: Object.assign({}, emptyAddress),
        addresses: [],
        selectedAddress: null,
    },
    getters: {
        getFirstName: state => state.address.firstName,
        getLastName: state => state.address.lastName,
        getCompany: state => state.address.company,
        getStreet: state => state.address.street,
        getPostCode: state => state.address.postCode,
        getCity: state => state.address.city,
        getCountry: state => state.address.country,
        getHouseNumber: state => state.address.houseNumber,
    },
    mutations: {
        setFirstName(state, value) {
            Vue.set(state.address, 'firstName', value);
        },
        setLastName(state, value) {
            Vue.set(state.address, 'lastName', value);
        },
        setCompany(state, value) {
            Vue.set(state.address, 'company', value);
        },
        setStreet(state, value) {
            Vue.set(state.address, 'street', value);
        },
        setPostCode(state, value) {
            Vue.set(state.address, 'postCode', value);
        },
        setCity(state, value) {
            Vue.set(state.address, 'city', value);
        },
        setCountry(state, value) {
            Object.values(Vue.$country.getCountries()).some(country => {
                if (value === country.iso_2 || value === country.name) {
                    Vue.set(state.address, 'country', country.iso_2);
                    return true;
                }
            });
        },
        setHouseNumber(state, value) {
            Vue.set(state.address, 'houseNumber', value);
        },
        setAddress(state, values) {
            if (values) {
                Object.keys(values).forEach(indexName => {
                    if (state.address.hasOwnProperty(indexName)) {
                        if (indexName === 'country') {
                            Object.values(Vue.$country.getCountries()).some(country => {
                                if (values[indexName] === country.iso_2) {
                                    Vue.set(state.address, 'country', country.iso_2);
                                    return true;
                                }
                            });
                        } else {
                            Vue.set(state.address, indexName, values[indexName]);
                        }
                    }
                });
            }
        },
        setAddresses(state, addresses) {
            state.addresses = addresses || [];
        },
        setLoading(state, value) {
            Vue.set(state, 'loading', value);
        },
        resetAddress(state, value) {
            for (let field of Object.keys(emptyAddress)) {
                Vue.set(state.address, field, emptyAddress[field]);
            }
        },
        setSelectedAddress(state, selectedAddress) {
            state.selectedAddress = selectedAddress;
        },
        loadDataFromSession(state) {
            const addressData = Vue.$session.get('customer-address-shipping') || {};
            const keys = Object.keys(addressData);
            if (keys.length) {
                for (const key of keys) {
                    if (state.address.hasOwnProperty(key) && addressData[key]) {
                        state.address[key] = addressData[key];
                    }
                }
            }
        },
    },
    actions: {
        loadAddress({state, commit, rootGetters}, setAddress = true) {
            if (rootGetters['Login/isUserLoggedIn']) {
                return Vue.$graphql
                    .query({
                        query: gql`
                            query getShippingAddresses {
                                getShippingAddresses {
                                    id
                                    city
                                    country
                                    firstName
                                    lastName
                                    company
                                    postCode
                                    street
                                    houseNumber
                                }
                            }
                        `,
                        fetchPolicy: 'no-cache',
                    })
                    .then(r => r.data)
                    .then(data => {
                        let address;
                        const addresses = data.getShippingAddresses;
                        if (addresses.length > 0) {
                            address = data.getShippingAddresses[0];
                        }
                        commit('setAddresses', addresses);
                        if (setAddress) {
                            commit('setAddress', address);
                        }

                        return address;
                    })
                    .catch(() => {
                        return {};
                    });
            } else {
                commit('loadDataFromSession');

                return Promise.resolve(state.address);
            }
        },
        saveAddress({state, commit, rootGetters}) {
            //@todo: We need to detect if there were any changes to address done and to not save it if it's the same
            commit('setLoading', true);
            let data = state.address;

            if (rootGetters['Login/isUserLoggedIn']) {
                return Vue.$graphql
                    .mutate({
                        mutation: gql`
                        mutation($addressData: CustomerShippingAddressInput!) {
                            addShippingAddress(addressData: $addressData) {
                                id
                                city
                                country
                                firstName
                                lastName
                                company
                                postCode
                                street
                                houseNumber
                            }
                        }
                    `,
                        variables: {
                            addressData: {
                                ...data,
                            },
                        },
                    })
                    .then(r => r.data)
                    .then(result => {
                        let address = result.addShippingAddress;
                        commit('setAddress', address);
                        commit('setLoading', false);

                        return address;
                    })
                    .catch(() => {
                        commit('setLoading', false);
                        return {};
                    });
            } else {
                Vue.$session.set('customer-address-shipping', data);
                commit('setLoading', false);

                return Promise.resolve(data);
            }
        },
        deleteAddress({}, address) {
            return Vue.$graphql
                .mutate({
                    mutation: gql`
                        mutation($id: String!) {
                            deleteShippingAddress(id: $id) {
                                success
                            }
                        }
                    `,
                    variables: {
                        id: address.id,
                    },
                })
                .then(r => r.data.deleteShippingAddress)
                .then(result => {
                    return result.success;
                })
                .catch(() => {
                    return false;
                });
        },
    },
};
